import './cart.css';
import gored from '../assets/gored.jpg'
import kitfo from '../assets/kitfo.jpg'
import tibs from '../assets/tibs.jpg'
import zighinivg from '../assets/zighinivg.jpg'
import zighini from '../assets/zighini.jpg'
import sambusa from '../assets/sambusa.jpg'
import sambusavg from '../assets/sambusavg.jpg'
import categna from '../assets/categna.jpg'
import Sorbetto from '../assets/Sorbetto.jpg'
import dolci1 from '../assets/dolci1.jpg'
import semolino from '../assets/semolino.jpg'
import water from '../assets/water.jpg'
import water2 from '../assets/water2.jpg'
import vino from '../assets/vino.jpg'
import vino2 from '../assets/vino2.jpg'
import softdrinks from '../assets/softdrinks.jpg'
import beer from '../assets/beer.jpg'
import beer2 from '../assets/beer2.jpg'
import limon from '../assets/limon.jpg'
import grappa from '../assets/grappa.png'
import coffee from '../assets/coffee.jpg'
import corretto from '../assets/corretto.jpg'
import tisana from '../assets/tisana.jpg'

import {orderContext} from '../Contexts/OrderProvider'
import React, { useEffect, useRef, useState,useContext} from 'react';
import { BrowserRouter as Router ,Switch,Route,useHistory } from 'react-router-dom';
const Cart = (props) => {
  const [orders,addOrders] = useContext(orderContext);
  const [sum,addSum]=useState(0);
  const history =useHistory();
  function calculateTotal(){
  var total=0;
  orders.forEach(element => {
     total+=element.total
  });
return total;
}
  function useForceUpdate(){
    const [value, setValue] = useState(0); // integer state
    return () => setValue(value => value + 1); // update the state to force render
  }
  const forceUpdate = useForceUpdate();
  const addQuantity=(event)=>{
    forceUpdate();
      var button=event.target.name;
      orders.forEach(element => {
        if(button == element.item){
             element.quantity=element.quantity+1;
             element.total=element.quantity*element.price;
                 calculateTotal();
            }
     });
  }
  const subQuantity=(event)=>{
    forceUpdate();
    var button=event.target.name;
    var counter=0;
    orders.forEach(element => {
      
      if(button == element.item){
         if(element.quantity>1){
           element.quantity=element.quantity-1;
           element.total=element.quantity*element.price;
           calculateTotal();}
           else{
             orders.splice(counter,1);
           }
           counter++;
      }
      else{
        counter++;
      }
   });
}

  const orderList=orders.map((element)=>{
  
    return(
      
     <tr>
     <td class="p-4">
       <div class="media align-items-center">
         <img src={element.image} class="d-block ui-w-40 ui-bordered mr-4" alt="" width="200px" ></img>
         <div class="media-body">
           <a href="#" class="d-block text-dark">{element.item}</a>
           <small>
           
           </small>
         </div>
       </div>
     </td>
     <td class="text-right font-weight-semibold align-middle p-4">${element.price}</td>
     <td class="align-middle p-4"><input type="text" class="form-control text-center" value={element.quantity}></input></td>
     <td class="text-right font-weight-semibold align-middle p-4">${element.total}</td>
     <td class="text-center align-middle px-0"><a href="#" class="shop-tooltip close float-none text-danger" title="" data-original-title="Remove"><button className={element.item} onClick={addQuantity} name={element.item}>+</button><button className={element.item} onClick={subQuantity} name={element.item}>-</button></a></td>
   </tr>
   
    );
 
    
    })
    return (

      <div>
            <div>
               <h1> Orders </h1> 
              
            </div>   
            <div>
            <div class="container px-3 my-5 clearfix">

    <div className="frame">
        
        <div className="card-body">
            <div class="table-responsive">
              <table class="table table-bordered m-0">
                <thead>
                  <tr>
                   
                    <th class="text-center py-3 px-4" >Product Name &amp; Details</th>
                    <th class="text-right py-3 px-4" >Price</th>
                    <th class="text-center py-3 px-4" >Quantity</th>
                    <th class="text-right py-3 px-4" >Total</th>
                    <th class="text-center align-middle py-3 px-0" ><a href="#" class="shop-tooltip float-none text-light" title="" data-original-title="Clear cart"><i class="ino ion-md-trash"></i></a></th>
                  </tr>
                </thead>
                <tbody>
           {orderList}
                           
                
        
                 
        
                </tbody>
              </table>
            </div>
          
        
            <div class="d-flex flex-wrap justify-content-between align-items-center pb-4">
              
              <div class="d-flex">
               
                <div class="text-right mt-4">
                  <label class="text-muted font-weight-normal m-0">Total price</label>
                  <div class="text-large"><strong>${calculateTotal()}</strong></div>
                </div>
              </div>
            </div>
        
            <div class="float-right">
              <button type="button" class="btn btn-lg btn-default md-btn-flat mt-2 mr-3" onClick={()=>{
                history.replace('/Reservation');
              }}>Back to shopping</button>
              <button type="button" class="btn btn-lg btn-primary mt-2" onClick={()=>{
                history.replace('/Form');
              }}>Checkout</button>
            </div>
        
          </div>
      </div>
  </div>      
            </div>
      </div>
    );
    
}
 
export default Cart;